import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import { change, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import classnames from "classnames";
import SystemReview from "./SystemReviewTemplate";
import PhysicalExamTemplate from "./PhysicalExamTemplate";
import ProceduresTempleate from "./ProceduresTempleate";
import LabsTemplates from "./LabsTemplates";
import Spinner from "react-bootstrap/Spinner";
import Modal from "../../../shared/components/Modal";
import NuclearTemplates from "./NuclearTemplates";
import HistoryTemplates from "./HistoryTemplates";
import StudyNuclearResults from "./StudyNuclearResults";
import SpeechTerapyResults from "./SpeechTerapyResults";
import InformedConsent from "./InformedConsent";
import InformedConsentNoRefund from "./InformedConsentNoRefund";
import SurveyQuestions from "./SurveyQuestions";
import LabsPatientTemplates from "./LabsPatientTemplates";
import AnanmesisTemplate from "./AnamnesisTemplate";
import MedicalPlanTemplate from "./MedicalPlanTemplate";
import ProceduresTemplateMulti from "./ProceduresTemplateMulti";
import AttetionAdmission from "./AttetionAdmission";

const ailmentsSystemReview = [
  "Síntomas Generales",
  "Respiratorios",
  "Cardiovascular",
  "Gastrointestinal",
  "Genitourinario",
  "Osteomuscular",
  "Dermatologico",
  "Endocrino",
  "Neurologico",
];

class TabsTopTempletes extends Component {
  constructor() {
    super();
    this.state = {
      btnActive: true,
      activeTab: "1",
      loadTab: false,
      idTemplate: "",
      idClinica: sessionStorage.getItem("id_clinica"),
      update: true,
      SystemReview: {
        ailments: (() => {
          return ailmentsSystemReview.map((ailment) => {
            return { ailment: ailment, commentary: "" };
          });
        })(),
      },
      PhysicalExam: {
        generalFeatures: "",
        headAndFace: "",
        ori: "",
        eyes: "",
        neck: "",
        chest: "",
        cardioVascular: "",
        pulmonary: "",
        abdomen: "",
        limbs: "",
        neurological: "",
        genitourinary: "",
        skin_appendages: "",
        otorrino: "",
      },
      MedicalProcedures: {
        ECO: {
          description: "",
          conclusions: "",
        },
        Stress: {
          description: "",
          conclusions: "",
        },
        Test: {
          conclusion: "",
          conclusions: "",
        },
        Holter: {
          conclusion: "",
        },
        Map: {
          conclusion: "",
        },
        EKG: {
          conclusions: "",
        },
      },
      examResults: {
        results: "",
        notes: "",
      },
      historia_nuclear: {
        antecedentes: "",
        tecnica: "",
        descripcion: "",
        opinion: "",
        obseravcion: "",
        nota: "",
      },
      informes: {
        motivo_consulta: "",
        resultados: "",
        recomendaciones: "",
        descripcion: "",
        parametros: "",
        nota: "",
        conclusion: "",
        observaciones: "",
      },
      openAlert: false,
      modalAlert: { message: "", color: "", title: "" },
      informedConsent: null,
      informedConsentNoRefund: null,
      nuclearTemplates: JSON.parse(sessionStorage.getItem("clinica")).tipo.some(
        (tip) => tip.value == "3"
      ),
    };
  }

  componentDidMount() {
    this.loadDataTempletes(this.state.idClinica);
  }

  loadDataTempletes = async (id) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "historia-plantillas/consultar?id_clinica=" +
        id,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.plantilla === null) {
          this.setState({ update: false, loadTab: true });
        }else {
          this.setDataTemplates(data.plantilla);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  

  setDataTemplates = (data) => {
    this.setState({
      PhysicalExam: {
        generalFeatures: data.examen_fisico.generalFeatures,
        headAndFace: data.examen_fisico.headAndFace,
        ori: data.examen_fisico.ori,
        eyes: data.examen_fisico.eyes,
        neck: data.examen_fisico.neck,
        chest: data.examen_fisico.chest,
        cardioVascular: data.examen_fisico.cardioVascular,
        pulmonary: data.examen_fisico.pulmonary,
        abdomen: data.examen_fisico.abdomen,
        limbs: data.examen_fisico.limbs,
        neurological: data.examen_fisico.neurological,
        genitourinary: data.examen_fisico.genitourinary,
        skin_appendages: data.examen_fisico.skin_appendages,
        otorrino:
          data.examen_fisico.otorrino != null &&
          data.examen_fisico.otorrino != undefined
            ? data.examen_fisico.otorrino
            : "",
      },
      MedicalProcedures: {
        ECO: {
          description: data.procedimientos.ECO.description,
          conclusions: data.procedimientos.ECO.conclusions,
        },
        Stress: {
          description: data.procedimientos.Stress.description,
          conclusions: data.procedimientos.Stress.conclusions,
        },
        Test: {
          conclusion: data.procedimientos.Test.conclusion,
          conclusions: data.procedimientos.Test.conclusions,
        },
        Holter: {
          conclusion: data.procedimientos.Holter.conclusion,
        },
        Map: {
          conclusion: data.procedimientos.Map.conclusion,
        },
        EKG: {
          conclusions: data.procedimientos.EKG.conclusions,
        },
      },
      SystemReview: {
        ailments: [
          {
            ailment: ailmentsSystemReview[0],
            commentary: data.revision_por_sistema.sintomas_generales,
          },
          {
            ailment: ailmentsSystemReview[1],
            commentary: data.revision_por_sistema.respiratorios,
          },
          {
            ailment: ailmentsSystemReview[2],
            commentary: data.revision_por_sistema.cardio_vascular,
          },
          {
            ailment: ailmentsSystemReview[3],
            commentary: data.revision_por_sistema.gastrointestintal,
          },
          {
            ailment: ailmentsSystemReview[4],
            commentary: data.revision_por_sistema.genitourinario,
          },
          {
            ailment: ailmentsSystemReview[5],
            commentary: data.revision_por_sistema.osteomuscular,
          },
          {
            ailment: ailmentsSystemReview[6],
            commentary: data.revision_por_sistema.dermatologico,
          },
          {
            ailment: ailmentsSystemReview[7],
            commentary: data.revision_por_sistema.endocrino,
          },
          {
            ailment: ailmentsSystemReview[8],
            commentary: data.revision_por_sistema.neurologico,
          },
        ],
      },
      examResults: {
        results: data.resultados_examenes.results,
        notes: data.resultados_examenes.notes,
      },
      historia_nuclear: {
        antecedentes: data.historia_nuclear.antecedentes,
        tecnica: data.historia_nuclear.tecnica,
        descripcion: data.historia_nuclear.descripcion,
        opinion: data.historia_nuclear.opinion,
        observacion: data.historia_nuclear.observacion,
        nota: data.historia_nuclear.nota,
      },
      informes: {
        motivo_consulta:
          data.informes !== null ? data.informes.motivo_consulta : "",
        resultados: data.informes !== null ? data.informes.resultados : "",
        recomendaciones:
          data.informes !== null ? data.informes.recomendaciones : "",
        descripcion: data.informes !== null ? data.informes.descripcion : "",
        parametros: data.informes !== null ? data.informes.parametros : "",
        observaciones:
          data.informes !== null ? data.informes.observaciones : "",
        nota: data.informes !== null ? data.informes.nota : "",
        conclusion: data.informes !== null ? data.informes.conclusion : "",
      },
      idTemplate: data.id_historia_plantilla,
      loadTab: true,
      informedConsent: data.consentimiento_informado,
      informedConsentNoRefund: data.consentimiento_no_reembolso,
    });
  };

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  handlerPhysicalExam = (physicalName, value) => {
    this.setState({
      PhysicalExam: { ...this.state.PhysicalExam, [physicalName]: value },
    });
  };

  handlerCommentsSystemReview = (commentary, index) => {
    var ailments = this.state.SystemReview.ailments;
    ailments[index].commentary = commentary;
    this.setState({ SystemReview: { ailments: ailments } });
  };

  handlerMedicalProcedures = (section, variable, value) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          [variable]: value,
        },
      },
    });
  };

  handlerNuclear = (nuclearField, value) => {
    this.setState({
      historia_nuclear: {
        ...this.state.historia_nuclear,
        [nuclearField]: value,
      },
    });
  };

  handlerLabsResults = (labField, value) => {
    this.setState({
      examResults: { ...this.state.examResults, [labField]: value },
    });
  };

  handlerHistoryInfo = (historyField, value) => {
    this.setState({
      informes: { ...this.state.informes, [historyField]: value },
    });
  };

  handlerInformedConsent = (value) => {
    this.setState({ informedConsent: value });
  };

  handlerInformedConsentNoRefund = (value) => {
    this.setState({ informedConsentNoRefund: value });
  };

  updateTemplate = async () => {
    const dataSend = {
      id_historia_plantilla: this.state.idTemplate,
      revision_por_sistema: {
        sintomas_generales: this.state.SystemReview.ailments[0].commentary,
        respiratorios: this.state.SystemReview.ailments[1].commentary,
        cardio_vascular: this.state.SystemReview.ailments[2].commentary,
        gastrointestintal: this.state.SystemReview.ailments[3].commentary,
        genitourinario: this.state.SystemReview.ailments[4].commentary,
        osteomuscular: this.state.SystemReview.ailments[5].commentary,
        dermatologico: this.state.SystemReview.ailments[6].commentary,
        endocrino: this.state.SystemReview.ailments[7].commentary,
        neurologico: this.state.SystemReview.ailments[8].commentary,
      },
      examen_fisico: this.state.PhysicalExam,
      procedimientos: this.state.MedicalProcedures,
      resultados_examenes: this.state.examResults,
      historia_nuclear: this.state.historia_nuclear,
      informes: this.state.informes,
      consentimiento_informado: this.state.informedConsent,
      consentimiento_no_reembolso: this.state.informedConsentNoRefund,
    };

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "historia-plantillas/update",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Ha ocurrido un error en el servidor`);
        }
      })
      .then((data) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Plantillas actualizadas con exito",
            color: "success",
            title: "Exitoso!",
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  createTemplate = async () => {
    const dataSend = {
      id_clinica: this.state.idClinica,
      revision_por_sistema: {
        sintomas_generales: this.state.SystemReview.ailments[0].commentary,
        respiratorios: this.state.SystemReview.ailments[1].commentary,
        cardio_vascular: this.state.SystemReview.ailments[2].commentary,
        gastrointestintal: this.state.SystemReview.ailments[3].commentary,
        genitourinario: this.state.SystemReview.ailments[4].commentary,
        osteomuscular: this.state.SystemReview.ailments[5].commentary,
        dermatologico: this.state.SystemReview.ailments[6].commentary,
        endocrino: this.state.SystemReview.ailments[7].commentary,
        neurologico: this.state.SystemReview.ailments[8].commentary,
      },
      examen_fisico: this.state.PhysicalExam,
      procedimientos: this.state.MedicalProcedures,
      resultados_examenes: this.state.examResults,
      historia_nuclear: this.state.historia_nuclear,
      informes: this.state.informes,
      consentimiento_informado: this.state.informedConsent,
      consentimiento_no_reembolso: this.state.informedConsentNoRefund,
    };

    //console.log(dataSend);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "historia-plantillas/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Ha ocurrido un error en el servidor`);
        }
      })
      .then((data) => {
        console.log(data);
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Plantilla creada con exito",
            color: "success",
            title: "Exitoso!",
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  render() {
    const { activeTab } = this.state;

    return (
      <Card>
        <CardBody>
          {this.state.loadTab ? (
            <div className="tabs tabs--bordered-top">
              <div className="tabs__wrap">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      Revision por Sistema
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        this.toggle("2");
                      }}
                    >
                      Examen Físico
                    </NavLink>
                  </NavItem>

                  {/*
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '3' })}
                                                onClick={() => {
                                                    this.toggle('3');
                                                }}
                                            >
                                                Procedimientos
                                            </NavLink>
                                        </NavItem>*/}

                  {
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "15" })}
                        onClick={() => {
                          this.toggle("15");
                        }}
                      >
                        Procedimientos
                      </NavLink>
                    </NavItem>
                  }

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" })}
                      onClick={() => {
                        this.toggle("4");
                      }}
                    >
                      Laboratorio
                    </NavLink>
                  </NavItem>
                  {this.state.nuclearTemplates == true ? (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" })}
                        onClick={() => {
                          this.toggle("5");
                        }}
                      >
                        Historia Nuclear
                      </NavLink>
                    </NavItem>
                  ) : null}

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "6" })}
                      onClick={() => {
                        this.toggle("6");
                      }}
                    >
                      Historia Informes
                    </NavLink>
                  </NavItem>

                  {this.state.nuclearTemplates == true ? (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" })}
                        onClick={() => {
                          this.toggle("7");
                        }}
                      >
                        Resultados de Estudio (H. Nuclear)
                      </NavLink>
                    </NavItem>
                  ) : null}

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "8" })}
                      onClick={() => {
                        this.toggle("8");
                      }}
                    >
                      Resultados de Fonoaudiologia
                    </NavLink>
                  </NavItem>

                  {this.state.nuclearTemplates == true ? (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "9" })}
                        onClick={() => {
                          this.toggle("9");
                        }}
                      >
                        Consentimiento Informado
                      </NavLink>
                    </NavItem>
                  ) : null}

                  {this.state.nuclearTemplates == true ? (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "10" })}
                        onClick={() => {
                          this.toggle("10");
                        }}
                      >
                        Formato de No Reembolso
                      </NavLink>
                    </NavItem>
                  ) : null}

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "11" })}
                      onClick={() => {
                        this.toggle("11");
                      }}
                    >
                      Encuesta
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "12" })}
                      onClick={() => {
                        this.toggle("12");
                      }}
                    >
                      Laboratorio
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "13" })}
                      onClick={() => {
                        this.toggle("13");
                      }}
                    >
                      Anamnesis
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "14" })}
                      onClick={() => {
                        this.toggle("14");
                      }}
                    >
                      Analisis y Plan Medico
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "16" })}
                      onClick={() => {
                        this.toggle("16");
                      }}
                    >
                      Certificado de Admisión
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <SystemReview
                      ailments={this.state.SystemReview.ailments}
                      handlerCommentsSystemReview={
                        this.handlerCommentsSystemReview
                      }
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <PhysicalExamTemplate
                      data={this.state.PhysicalExam}
                      handlerPhysicalExam={this.handlerPhysicalExam}
                    />
                  </TabPane>

                  {/*
                                         <TabPane tabId="3">
                                        <ProceduresTempleate
                                            data={this.state.MedicalProcedures}
                                            handlerMedicalProcedures={this.handlerMedicalProcedures} />
                                    </TabPane>
                                         */}

                  <TabPane tabId="4">
                    <LabsTemplates
                      data={this.state.examResults}
                      handlerLabsResults={this.handlerLabsResults}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <NuclearTemplates
                      data={this.state.historia_nuclear}
                      handlerNuclear={this.handlerNuclear}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <HistoryTemplates
                      data={this.state.informes}
                      handlerHistoryInfo={this.handlerHistoryInfo}
                    />
                  </TabPane>
                  <TabPane tabId="7">
                    <StudyNuclearResults />
                  </TabPane>
                  <TabPane tabId="8">
                    <SpeechTerapyResults />
                  </TabPane>
                  <TabPane tabId="9">
                    {this.state.informedConsent != null ?
                      <InformedConsent
                        data={this.state.informedConsent}
                        handlerInformedConsent={this.handlerInformedConsent}
                      />:null}
                  </TabPane>
                  <TabPane tabId="10">
                    <InformedConsentNoRefund
                      data={this.state.informedConsentNoRefund}
                      handlerInformedConsentNoRefund={
                        this.handlerInformedConsentNoRefund
                      }
                    />
                  </TabPane>
                  <TabPane tabId="11">
                    <SurveyQuestions />
                  </TabPane>
                  <TabPane tabId="12">
                    <LabsPatientTemplates />
                  </TabPane>
                  <TabPane tabId="13">
                    <AnanmesisTemplate />
                  </TabPane>
                  <TabPane tabId="14">
                    <MedicalPlanTemplate />
                  </TabPane>
                  <TabPane tabId="15">
                    <ProceduresTemplateMulti />
                  </TabPane>
                  <TabPane tabId="16">
                    <AttetionAdmission />
                  </TabPane>
                </TabContent>
              </div>
              <div>
                {activeTab != "7" &&
                activeTab != "8" &&
                activeTab != "11" &&
                activeTab != "12" &&
                activeTab != "13" &&
                activeTab != "14" &&
                activeTab != "15" &&
                activeTab != "16" ? (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.state.update == true) {
                        this.updateTemplate();
                      } else {
                        this.createTemplate();
                      }
                    }}
                  >
                    Guardar
                  </Button>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
          <Modal
            color={this.state.modalAlert.color}
            title={this.state.modalAlert.title}
            message={this.state.modalAlert.message}
            modal={this.state.openAlert}
            toggle={() => {
              this.setState({ openAlert: !this.state.openAlert });
            }}
            onOk={() => {
              this.setState({ openAlert: !this.state.openAlert });
            }}
          />
        </CardBody>
      </Card>
    );
  }
}

export default reduxForm({
  form: "templetes_form", // a unique identifier for this form
})(withTranslation("common")(TabsTopTempletes));
